import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { ReactTags } from "react-tag-autocomplete";
import ValidationError from "@client.components/ValidationError";
import TagsList from "./TagsList";
import "./TagAutocomplete.scss";
import "./TagAutocompleteListBox.scss";

const TagAutocomplete = ({
  items,
  placeholderText,
  allowNew,
  noOptionsText,
  newOptionText,
  onSelect,
  error,
  value = [],
}) => {
  const onAdd = useCallback(
    (newTag) => {
      newTag.label = newTag.label.trim();

      const compareLabels = ({ label }) =>
        label.toLowerCase() === newTag.label.toLowerCase();
      const existingTag = items.find(compareLabels);
      const isTagAlreadySelected = value.find(compareLabels);
      if (!isTagAlreadySelected) {
        const list = [
          ...value,
          existingTag ? existingTag : { value: null, label: newTag.label },
        ];
        onSelect(list);
      }
    },
    [onSelect, value, items]
  );

  const onDelete = useCallback(
    (tagIndex) => {
      const list = value.filter((_, i) => i !== tagIndex);
      onSelect(list);
    },
    [onSelect, value]
  );

  return (
    <div className="tag-autocomplete">
      <ReactTags
        placeholderText={placeholderText}
        allowNew={allowNew}
        collapseOnSelect
        allowBackspace
        selected={value}
        suggestions={items}
        onAdd={onAdd}
        onDelete={onDelete}
        noOptionsText={noOptionsText}
        newOptionText={newOptionText}
        renderTag={() => null}
        isInvalid={!!error}
        renderLabel={() => null}
      />
      <ValidationError error={error} />
      <TagsList selected={value} onDelete={onDelete} />
    </div>
  );
};

TagAutocomplete.propTypes = {
  value: PropTypes.array,
  error: PropTypes.array,
  newOptionText: PropTypes.string,
  noOptionsText: PropTypes.string,
  placeholderText: PropTypes.string,
  allowNew: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      labelText: PropTypes.string,
    })
  ),
};

export default TagAutocomplete;
